"use strict";

var cov_2re07f8jxs = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\selections\\selections.js";
  var hash = "d4328f5dbfc08526fc93128268b66ea623460c77";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\selections\\selections.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 50
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 19
        },
        end: {
          line: 11,
          column: 21
        }
      },
      "2": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 15,
          column: 3
        }
      },
      "3": {
        start: {
          line: 13,
          column: 19
        },
        end: {
          line: 13,
          column: 53
        }
      },
      "4": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 77
        }
      },
      "5": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 20
        }
      },
      "6": {
        start: {
          line: 19,
          column: 39
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "7": {
        start: {
          line: 20,
          column: 26
        },
        end: {
          line: 20,
          column: 44
        }
      },
      "8": {
        start: {
          line: 21,
          column: 45
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "9": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 34
        }
      },
      "10": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 46
        }
      },
      "11": {
        start: {
          line: 31,
          column: 44
        },
        end: {
          line: 77,
          column: 1
        }
      },
      "12": {
        start: {
          line: 36,
          column: 15
        },
        end: {
          line: 36,
          column: 41
        }
      },
      "13": {
        start: {
          line: 37,
          column: 18
        },
        end: {
          line: 37,
          column: 55
        }
      },
      "14": {
        start: {
          line: 38,
          column: 19
        },
        end: {
          line: 38,
          column: 21
        }
      },
      "15": {
        start: {
          line: 39,
          column: 22
        },
        end: {
          line: 39,
          column: 42
        }
      },
      "16": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 42,
          column: 3
        }
      },
      "17": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 14
        }
      },
      "18": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "19": {
        start: {
          line: 45,
          column: 24
        },
        end: {
          line: 45,
          column: 58
        }
      },
      "20": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 51
        }
      },
      "21": {
        start: {
          line: 49,
          column: 29
        },
        end: {
          line: 49,
          column: 30
        }
      },
      "22": {
        start: {
          line: 50,
          column: 22
        },
        end: {
          line: 50,
          column: 24
        }
      },
      "23": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 75,
          column: 5
        }
      },
      "24": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 76
        }
      },
      "25": {
        start: {
          line: 53,
          column: 30
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "26": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 63,
          column: 6
        }
      },
      "27": {
        start: {
          line: 65,
          column: 26
        },
        end: {
          line: 70,
          column: 6
        }
      },
      "28": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 75
        }
      },
      "29": {
        start: {
          line: 72,
          column: 44
        },
        end: {
          line: 72,
          column: 73
        }
      },
      "30": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 30
        }
      },
      "31": {
        start: {
          line: 76,
          column: 2
        },
        end: {
          line: 76,
          column: 20
        }
      },
      "32": {
        start: {
          line: 86,
          column: 53
        },
        end: {
          line: 96,
          column: 1
        }
      },
      "33": {
        start: {
          line: 91,
          column: 2
        },
        end: {
          line: 95,
          column: 3
        }
      },
      "34": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 22
        }
      },
      "35": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 36
        }
      },
      "36": {
        start: {
          line: 106,
          column: 37
        },
        end: {
          line: 122,
          column: 1
        }
      },
      "37": {
        start: {
          line: 107,
          column: 25
        },
        end: {
          line: 107,
          column: 41
        }
      },
      "38": {
        start: {
          line: 108,
          column: 14
        },
        end: {
          line: 118,
          column: 3
        }
      },
      "39": {
        start: {
          line: 119,
          column: 17
        },
        end: {
          line: 119,
          column: 33
        }
      },
      "40": {
        start: {
          line: 120,
          column: 18
        },
        end: {
          line: 120,
          column: 41
        }
      },
      "41": {
        start: {
          line: 121,
          column: 2
        },
        end: {
          line: 121,
          column: 20
        }
      },
      "42": {
        start: {
          line: 131,
          column: 32
        },
        end: {
          line: 144,
          column: 1
        }
      },
      "43": {
        start: {
          line: 132,
          column: 17
        },
        end: {
          line: 132,
          column: 33
        }
      },
      "44": {
        start: {
          line: 133,
          column: 20
        },
        end: {
          line: 133,
          column: 42
        }
      },
      "45": {
        start: {
          line: 135,
          column: 2
        },
        end: {
          line: 143,
          column: 3
        }
      },
      "46": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 58
        }
      },
      "47": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 142,
          column: 59
        }
      },
      "48": {
        start: {
          line: 146,
          column: 41
        },
        end: {
          line: 171,
          column: 1
        }
      },
      "49": {
        start: {
          line: 153,
          column: 25
        },
        end: {
          line: 153,
          column: 44
        }
      },
      "50": {
        start: {
          line: 154,
          column: 24
        },
        end: {
          line: 154,
          column: 26
        }
      },
      "51": {
        start: {
          line: 155,
          column: 2
        },
        end: {
          line: 169,
          column: 5
        }
      },
      "52": {
        start: {
          line: 158,
          column: 41
        },
        end: {
          line: 160,
          column: 16
        }
      },
      "53": {
        start: {
          line: 159,
          column: 25
        },
        end: {
          line: 159,
          column: 29
        }
      },
      "54": {
        start: {
          line: 161,
          column: 23
        },
        end: {
          line: 166,
          column: 6
        }
      },
      "55": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 168,
          column: 37
        }
      },
      "56": {
        start: {
          line: 170,
          column: 2
        },
        end: {
          line: 170,
          column: 23
        }
      },
      "57": {
        start: {
          line: 187,
          column: 33
        },
        end: {
          line: 216,
          column: 1
        }
      },
      "58": {
        start: {
          line: 193,
          column: 22
        },
        end: {
          line: 193,
          column: 49
        }
      },
      "59": {
        start: {
          line: 195,
          column: 26
        },
        end: {
          line: 195,
          column: 50
        }
      },
      "60": {
        start: {
          line: 196,
          column: 45
        },
        end: {
          line: 202,
          column: 6
        }
      },
      "61": {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 200,
          column: 38
        }
      },
      "62": {
        start: {
          line: 204,
          column: 19
        },
        end: {
          line: 204,
          column: 59
        }
      },
      "63": {
        start: {
          line: 206,
          column: 20
        },
        end: {
          line: 206,
          column: 42
        }
      },
      "64": {
        start: {
          line: 207,
          column: 23
        },
        end: {
          line: 209,
          column: 7
        }
      },
      "65": {
        start: {
          line: 208,
          column: 4
        },
        end: {
          line: 208,
          column: 38
        }
      },
      "66": {
        start: {
          line: 211,
          column: 2
        },
        end: {
          line: 215,
          column: 4
        }
      },
      "67": {
        start: {
          line: 223,
          column: 36
        },
        end: {
          line: 260,
          column: 1
        }
      },
      "68": {
        start: {
          line: 224,
          column: 23
        },
        end: {
          line: 224,
          column: 25
        }
      },
      "69": {
        start: {
          line: 225,
          column: 24
        },
        end: {
          line: 225,
          column: 30
        }
      },
      "70": {
        start: {
          line: 227,
          column: 19
        },
        end: {
          line: 227,
          column: 20
        }
      },
      "71": {
        start: {
          line: 228,
          column: 2
        },
        end: {
          line: 254,
          column: 5
        }
      },
      "72": {
        start: {
          line: 229,
          column: 35
        },
        end: {
          line: 229,
          column: 56
        }
      },
      "73": {
        start: {
          line: 230,
          column: 28
        },
        end: {
          line: 230,
          column: 76
        }
      },
      "74": {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 234,
          column: 5
        }
      },
      "75": {
        start: {
          line: 233,
          column: 6
        },
        end: {
          line: 233,
          column: 70
        }
      },
      "76": {
        start: {
          line: 235,
          column: 30
        },
        end: {
          line: 235,
          column: 51
        }
      },
      "77": {
        start: {
          line: 236,
          column: 28
        },
        end: {
          line: 236,
          column: 53
        }
      },
      "78": {
        start: {
          line: 237,
          column: 22
        },
        end: {
          line: 237,
          column: 79
        }
      },
      "79": {
        start: {
          line: 238,
          column: 30
        },
        end: {
          line: 238,
          column: 55
        }
      },
      "80": {
        start: {
          line: 239,
          column: 23
        },
        end: {
          line: 239,
          column: 76
        }
      },
      "81": {
        start: {
          line: 240,
          column: 24
        },
        end: {
          line: 240,
          column: 62
        }
      },
      "82": {
        start: {
          line: 241,
          column: 28
        },
        end: {
          line: 246,
          column: 5
        }
      },
      "83": {
        start: {
          line: 247,
          column: 4
        },
        end: {
          line: 247,
          column: 41
        }
      },
      "84": {
        start: {
          line: 249,
          column: 34
        },
        end: {
          line: 249,
          column: 59
        }
      },
      "85": {
        start: {
          line: 250,
          column: 4
        },
        end: {
          line: 250,
          column: 67
        }
      },
      "86": {
        start: {
          line: 252,
          column: 4
        },
        end: {
          line: 252,
          column: 41
        }
      },
      "87": {
        start: {
          line: 253,
          column: 4
        },
        end: {
          line: 253,
          column: 35
        }
      },
      "88": {
        start: {
          line: 255,
          column: 2
        },
        end: {
          line: 258,
          column: 3
        }
      },
      "89": {
        start: {
          line: 257,
          column: 4
        },
        end: {
          line: 257,
          column: 68
        }
      },
      "90": {
        start: {
          line: 259,
          column: 2
        },
        end: {
          line: 259,
          column: 24
        }
      },
      "91": {
        start: {
          line: 268,
          column: 34
        },
        end: {
          line: 284,
          column: 1
        }
      },
      "92": {
        start: {
          line: 269,
          column: 15
        },
        end: {
          line: 269,
          column: 17
        }
      },
      "93": {
        start: {
          line: 270,
          column: 2
        },
        end: {
          line: 282,
          column: 5
        }
      },
      "94": {
        start: {
          line: 271,
          column: 4
        },
        end: {
          line: 281,
          column: 5
        }
      },
      "95": {
        start: {
          line: 273,
          column: 25
        },
        end: {
          line: 273,
          column: 53
        }
      },
      "96": {
        start: {
          line: 274,
          column: 30
        },
        end: {
          line: 276,
          column: 29
        }
      },
      "97": {
        start: {
          line: 277,
          column: 20
        },
        end: {
          line: 277,
          column: 42
        }
      },
      "98": {
        start: {
          line: 278,
          column: 18
        },
        end: {
          line: 278,
          column: 51
        }
      },
      "99": {
        start: {
          line: 279,
          column: 20
        },
        end: {
          line: 279,
          column: 32
        }
      },
      "100": {
        start: {
          line: 280,
          column: 6
        },
        end: {
          line: 280,
          column: 25
        }
      },
      "101": {
        start: {
          line: 283,
          column: 2
        },
        end: {
          line: 283,
          column: 16
        }
      },
      "102": {
        start: {
          line: 292,
          column: 41
        },
        end: {
          line: 298,
          column: 1
        }
      },
      "103": {
        start: {
          line: 293,
          column: 27
        },
        end: {
          line: 293,
          column: 29
        }
      },
      "104": {
        start: {
          line: 294,
          column: 2
        },
        end: {
          line: 294,
          column: 54
        }
      },
      "105": {
        start: {
          line: 295,
          column: 17
        },
        end: {
          line: 295,
          column: 55
        }
      },
      "106": {
        start: {
          line: 296,
          column: 2
        },
        end: {
          line: 296,
          column: 60
        }
      },
      "107": {
        start: {
          line: 297,
          column: 2
        },
        end: {
          line: 297,
          column: 28
        }
      },
      "108": {
        start: {
          line: 305,
          column: 30
        },
        end: {
          line: 338,
          column: 1
        }
      },
      "109": {
        start: {
          line: 306,
          column: 24
        },
        end: {
          line: 306,
          column: 26
        }
      },
      "110": {
        start: {
          line: 307,
          column: 2
        },
        end: {
          line: 307,
          column: 41
        }
      },
      "111": {
        start: {
          line: 307,
          column: 27
        },
        end: {
          line: 307,
          column: 41
        }
      },
      "112": {
        start: {
          line: 308,
          column: 2
        },
        end: {
          line: 308,
          column: 49
        }
      },
      "113": {
        start: {
          line: 308,
          column: 39
        },
        end: {
          line: 308,
          column: 47
        }
      },
      "114": {
        start: {
          line: 309,
          column: 2
        },
        end: {
          line: 309,
          column: 49
        }
      },
      "115": {
        start: {
          line: 309,
          column: 39
        },
        end: {
          line: 309,
          column: 47
        }
      },
      "116": {
        start: {
          line: 310,
          column: 2
        },
        end: {
          line: 310,
          column: 26
        }
      },
      "117": {
        start: {
          line: 312,
          column: 21
        },
        end: {
          line: 312,
          column: 23
        }
      },
      "118": {
        start: {
          line: 313,
          column: 2
        },
        end: {
          line: 336,
          column: 5
        }
      },
      "119": {
        start: {
          line: 314,
          column: 25
        },
        end: {
          line: 314,
          column: 40
        }
      },
      "120": {
        start: {
          line: 315,
          column: 23
        },
        end: {
          line: 315,
          column: 38
        }
      },
      "121": {
        start: {
          line: 316,
          column: 23
        },
        end: {
          line: 316,
          column: 38
        }
      },
      "122": {
        start: {
          line: 317,
          column: 21
        },
        end: {
          line: 317,
          column: 36
        }
      },
      "123": {
        start: {
          line: 318,
          column: 4
        },
        end: {
          line: 331,
          column: 5
        }
      },
      "124": {
        start: {
          line: 320,
          column: 6
        },
        end: {
          line: 326,
          column: 7
        }
      },
      "125": {
        start: {
          line: 325,
          column: 8
        },
        end: {
          line: 325,
          column: 50
        }
      },
      "126": {
        start: {
          line: 329,
          column: 6
        },
        end: {
          line: 329,
          column: 72
        }
      },
      "127": {
        start: {
          line: 329,
          column: 37
        },
        end: {
          line: 329,
          column: 72
        }
      },
      "128": {
        start: {
          line: 330,
          column: 6
        },
        end: {
          line: 330,
          column: 34
        }
      },
      "129": {
        start: {
          line: 332,
          column: 4
        },
        end: {
          line: 335,
          column: 5
        }
      },
      "130": {
        start: {
          line: 334,
          column: 6
        },
        end: {
          line: 334,
          column: 41
        }
      },
      "131": {
        start: {
          line: 337,
          column: 2
        },
        end: {
          line: 337,
          column: 25
        }
      },
      "132": {
        start: {
          line: 346,
          column: 30
        },
        end: {
          line: 351,
          column: 1
        }
      },
      "133": {
        start: {
          line: 347,
          column: 23
        },
        end: {
          line: 347,
          column: 25
        }
      },
      "134": {
        start: {
          line: 348,
          column: 15
        },
        end: {
          line: 348,
          column: 68
        }
      },
      "135": {
        start: {
          line: 349,
          column: 2
        },
        end: {
          line: 349,
          column: 71
        }
      },
      "136": {
        start: {
          line: 350,
          column: 2
        },
        end: {
          line: 350,
          column: 24
        }
      },
      "137": {
        start: {
          line: 366,
          column: 34
        },
        end: {
          line: 388,
          column: 1
        }
      },
      "138": {
        start: {
          line: 367,
          column: 19
        },
        end: {
          line: 367,
          column: 21
        }
      },
      "139": {
        start: {
          line: 368,
          column: 2
        },
        end: {
          line: 386,
          column: 5
        }
      },
      "140": {
        start: {
          line: 369,
          column: 18
        },
        end: {
          line: 369,
          column: 26
        }
      },
      "141": {
        start: {
          line: 370,
          column: 16
        },
        end: {
          line: 370,
          column: 24
        }
      },
      "142": {
        start: {
          line: 371,
          column: 19
        },
        end: {
          line: 371,
          column: 34
        }
      },
      "143": {
        start: {
          line: 372,
          column: 22
        },
        end: {
          line: 372,
          column: 50
        }
      },
      "144": {
        start: {
          line: 373,
          column: 23
        },
        end: {
          line: 373,
          column: 46
        }
      },
      "145": {
        start: {
          line: 374,
          column: 26
        },
        end: {
          line: 374,
          column: 68
        }
      },
      "146": {
        start: {
          line: 375,
          column: 23
        },
        end: {
          line: 375,
          column: 40
        }
      },
      "147": {
        start: {
          line: 376,
          column: 24
        },
        end: {
          line: 376,
          column: 62
        }
      },
      "148": {
        start: {
          line: 377,
          column: 22
        },
        end: {
          line: 381,
          column: 5
        }
      },
      "149": {
        start: {
          line: 382,
          column: 4
        },
        end: {
          line: 385,
          column: 5
        }
      },
      "150": {
        start: {
          line: 384,
          column: 6
        },
        end: {
          line: 384,
          column: 33
        }
      },
      "151": {
        start: {
          line: 387,
          column: 2
        },
        end: {
          line: 387,
          column: 20
        }
      },
      "152": {
        start: {
          line: 396,
          column: 34
        },
        end: {
          line: 407,
          column: 1
        }
      },
      "153": {
        start: {
          line: 399,
          column: 2
        },
        end: {
          line: 402,
          column: 5
        }
      },
      "154": {
        start: {
          line: 400,
          column: 27
        },
        end: {
          line: 400,
          column: 70
        }
      },
      "155": {
        start: {
          line: 401,
          column: 4
        },
        end: {
          line: 401,
          column: 47
        }
      },
      "156": {
        start: {
          line: 403,
          column: 15
        },
        end: {
          line: 403,
          column: 53
        }
      },
      "157": {
        start: {
          line: 404,
          column: 2
        },
        end: {
          line: 404,
          column: 34
        }
      },
      "158": {
        start: {
          line: 405,
          column: 2
        },
        end: {
          line: 405,
          column: 59
        }
      },
      "159": {
        start: {
          line: 406,
          column: 2
        },
        end: {
          line: 406,
          column: 29
        }
      },
      "160": {
        start: {
          line: 415,
          column: 45
        },
        end: {
          line: 430,
          column: 1
        }
      },
      "161": {
        start: {
          line: 420,
          column: 2
        },
        end: {
          line: 420,
          column: 38
        }
      },
      "162": {
        start: {
          line: 421,
          column: 2
        },
        end: {
          line: 427,
          column: 4
        }
      },
      "163": {
        start: {
          line: 423,
          column: 6
        },
        end: {
          line: 426,
          column: 7
        }
      },
      "164": {
        start: {
          line: 428,
          column: 2
        },
        end: {
          line: 428,
          column: 54
        }
      },
      "165": {
        start: {
          line: 429,
          column: 2
        },
        end: {
          line: 429,
          column: 20
        }
      },
      "166": {
        start: {
          line: 438,
          column: 40
        },
        end: {
          line: 443,
          column: 1
        }
      },
      "167": {
        start: {
          line: 439,
          column: 2
        },
        end: {
          line: 439,
          column: 38
        }
      },
      "168": {
        start: {
          line: 440,
          column: 2
        },
        end: {
          line: 440,
          column: 29
        }
      },
      "169": {
        start: {
          line: 441,
          column: 2
        },
        end: {
          line: 441,
          column: 54
        }
      },
      "170": {
        start: {
          line: 442,
          column: 2
        },
        end: {
          line: 442,
          column: 20
        }
      },
      "171": {
        start: {
          line: 451,
          column: 42
        },
        end: {
          line: 472,
          column: 1
        }
      },
      "172": {
        start: {
          line: 452,
          column: 10
        },
        end: {
          line: 452,
          column: 11
        }
      },
      "173": {
        start: {
          line: 453,
          column: 2
        },
        end: {
          line: 453,
          column: 38
        }
      },
      "174": {
        start: {
          line: 453,
          column: 29
        },
        end: {
          line: 453,
          column: 38
        }
      },
      "175": {
        start: {
          line: 454,
          column: 2
        },
        end: {
          line: 460,
          column: 3
        }
      },
      "176": {
        start: {
          line: 455,
          column: 22
        },
        end: {
          line: 455,
          column: 42
        }
      },
      "177": {
        start: {
          line: 456,
          column: 4
        },
        end: {
          line: 458,
          column: 7
        }
      },
      "178": {
        start: {
          line: 457,
          column: 6
        },
        end: {
          line: 457,
          column: 62
        }
      },
      "179": {
        start: {
          line: 459,
          column: 4
        },
        end: {
          line: 459,
          column: 13
        }
      },
      "180": {
        start: {
          line: 461,
          column: 2
        },
        end: {
          line: 461,
          column: 76
        }
      },
      "181": {
        start: {
          line: 461,
          column: 33
        },
        end: {
          line: 461,
          column: 76
        }
      },
      "182": {
        start: {
          line: 462,
          column: 16
        },
        end: {
          line: 462,
          column: 55
        }
      },
      "183": {
        start: {
          line: 464,
          column: 2
        },
        end: {
          line: 470,
          column: 3
        }
      },
      "184": {
        start: {
          line: 466,
          column: 4
        },
        end: {
          line: 468,
          column: 5
        }
      },
      "185": {
        start: {
          line: 467,
          column: 6
        },
        end: {
          line: 467,
          column: 24
        }
      },
      "186": {
        start: {
          line: 469,
          column: 4
        },
        end: {
          line: 469,
          column: 8
        }
      },
      "187": {
        start: {
          line: 471,
          column: 2
        },
        end: {
          line: 471,
          column: 11
        }
      },
      "188": {
        start: {
          line: 482,
          column: 27
        },
        end: {
          line: 495,
          column: 1
        }
      },
      "189": {
        start: {
          line: 483,
          column: 2
        },
        end: {
          line: 483,
          column: 38
        }
      },
      "190": {
        start: {
          line: 483,
          column: 29
        },
        end: {
          line: 483,
          column: 38
        }
      },
      "191": {
        start: {
          line: 484,
          column: 10
        },
        end: {
          line: 484,
          column: 11
        }
      },
      "192": {
        start: {
          line: 485,
          column: 12
        },
        end: {
          line: 485,
          column: 13
        }
      },
      "193": {
        start: {
          line: 486,
          column: 13
        },
        end: {
          line: 486,
          column: 29
        }
      },
      "194": {
        start: {
          line: 488,
          column: 2
        },
        end: {
          line: 493,
          column: 3
        }
      },
      "195": {
        start: {
          line: 489,
          column: 4
        },
        end: {
          line: 489,
          column: 41
        }
      },
      "196": {
        start: {
          line: 490,
          column: 4
        },
        end: {
          line: 490,
          column: 26
        }
      },
      "197": {
        start: {
          line: 490,
          column: 20
        },
        end: {
          line: 490,
          column: 26
        }
      },
      "198": {
        start: {
          line: 491,
          column: 4
        },
        end: {
          line: 491,
          column: 8
        }
      },
      "199": {
        start: {
          line: 492,
          column: 4
        },
        end: {
          line: 492,
          column: 16
        }
      },
      "200": {
        start: {
          line: 494,
          column: 2
        },
        end: {
          line: 494,
          column: 11
        }
      },
      "201": {
        start: {
          line: 504,
          column: 41
        },
        end: {
          line: 510,
          column: 1
        }
      },
      "202": {
        start: {
          line: 505,
          column: 2
        },
        end: {
          line: 508,
          column: 5
        }
      },
      "203": {
        start: {
          line: 506,
          column: 16
        },
        end: {
          line: 506,
          column: 51
        }
      },
      "204": {
        start: {
          line: 507,
          column: 4
        },
        end: {
          line: 507,
          column: 43
        }
      },
      "205": {
        start: {
          line: 509,
          column: 2
        },
        end: {
          line: 509,
          column: 20
        }
      },
      "206": {
        start: {
          line: 520,
          column: 35
        },
        end: {
          line: 532,
          column: 1
        }
      },
      "207": {
        start: {
          line: 521,
          column: 2
        },
        end: {
          line: 521,
          column: 38
        }
      },
      "208": {
        start: {
          line: 521,
          column: 29
        },
        end: {
          line: 521,
          column: 38
        }
      },
      "209": {
        start: {
          line: 522,
          column: 20
        },
        end: {
          line: 522,
          column: 21
        }
      },
      "210": {
        start: {
          line: 523,
          column: 17
        },
        end: {
          line: 523,
          column: 18
        }
      },
      "211": {
        start: {
          line: 524,
          column: 13
        },
        end: {
          line: 524,
          column: 29
        }
      },
      "212": {
        start: {
          line: 525,
          column: 2
        },
        end: {
          line: 530,
          column: 3
        }
      },
      "213": {
        start: {
          line: 526,
          column: 4
        },
        end: {
          line: 526,
          column: 51
        }
      },
      "214": {
        start: {
          line: 527,
          column: 4
        },
        end: {
          line: 527,
          column: 31
        }
      },
      "215": {
        start: {
          line: 527,
          column: 25
        },
        end: {
          line: 527,
          column: 31
        }
      },
      "216": {
        start: {
          line: 528,
          column: 4
        },
        end: {
          line: 528,
          column: 18
        }
      },
      "217": {
        start: {
          line: 529,
          column: 4
        },
        end: {
          line: 529,
          column: 21
        }
      },
      "218": {
        start: {
          line: 531,
          column: 2
        },
        end: {
          line: 531,
          column: 21
        }
      },
      "219": {
        start: {
          line: 534,
          column: 18
        },
        end: {
          line: 540,
          column: 1
        }
      },
      "220": {
        start: {
          line: 535,
          column: 2
        },
        end: {
          line: 539,
          column: 5
        }
      },
      "221": {
        start: {
          line: 542,
          column: 31
        },
        end: {
          line: 545,
          column: 1
        }
      },
      "222": {
        start: {
          line: 543,
          column: 21
        },
        end: {
          line: 543,
          column: 48
        }
      },
      "223": {
        start: {
          line: 544,
          column: 2
        },
        end: {
          line: 544,
          column: 20
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 50
          },
          end: {
            line: 6,
            column: 51
          }
        },
        loc: {
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 39
          },
          end: {
            line: 19,
            column: 40
          }
        },
        loc: {
          start: {
            line: 19,
            column: 62
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 21,
            column: 68
          },
          end: {
            line: 21,
            column: 69
          }
        },
        loc: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 24
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 31,
            column: 44
          },
          end: {
            line: 31,
            column: 45
          }
        },
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 77,
            column: 1
          }
        },
        line: 35
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 51,
            column: 20
          },
          end: {
            line: 51,
            column: 21
          }
        },
        loc: {
          start: {
            line: 51,
            column: 41
          },
          end: {
            line: 75,
            column: 3
          }
        },
        line: 51
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 72,
            column: 26
          },
          end: {
            line: 72,
            column: 27
          }
        },
        loc: {
          start: {
            line: 72,
            column: 44
          },
          end: {
            line: 72,
            column: 73
          }
        },
        line: 72
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 86,
            column: 53
          },
          end: {
            line: 86,
            column: 54
          }
        },
        loc: {
          start: {
            line: 90,
            column: 5
          },
          end: {
            line: 96,
            column: 1
          }
        },
        line: 90
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 106,
            column: 37
          },
          end: {
            line: 106,
            column: 38
          }
        },
        loc: {
          start: {
            line: 106,
            column: 69
          },
          end: {
            line: 122,
            column: 1
          }
        },
        line: 106
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 131,
            column: 32
          },
          end: {
            line: 131,
            column: 33
          }
        },
        loc: {
          start: {
            line: 131,
            column: 78
          },
          end: {
            line: 144,
            column: 1
          }
        },
        line: 131
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 146,
            column: 41
          },
          end: {
            line: 146,
            column: 42
          }
        },
        loc: {
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 171,
            column: 1
          }
        },
        line: 150
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 155,
            column: 25
          },
          end: {
            line: 155,
            column: 26
          }
        },
        loc: {
          start: {
            line: 155,
            column: 44
          },
          end: {
            line: 169,
            column: 3
          }
        },
        line: 155
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 159,
            column: 11
          },
          end: {
            line: 159,
            column: 12
          }
        },
        loc: {
          start: {
            line: 159,
            column: 25
          },
          end: {
            line: 159,
            column: 29
          }
        },
        line: 159
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 187,
            column: 33
          },
          end: {
            line: 187,
            column: 34
          }
        },
        loc: {
          start: {
            line: 191,
            column: 6
          },
          end: {
            line: 216,
            column: 1
          }
        },
        line: 191
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 196,
            column: 68
          },
          end: {
            line: 196,
            column: 69
          }
        },
        loc: {
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 201,
            column: 3
          }
        },
        line: 199
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 207,
            column: 40
          },
          end: {
            line: 207,
            column: 41
          }
        },
        loc: {
          start: {
            line: 207,
            column: 58
          },
          end: {
            line: 209,
            column: 3
          }
        },
        line: 207
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 223,
            column: 36
          },
          end: {
            line: 223,
            column: 37
          }
        },
        loc: {
          start: {
            line: 223,
            column: 56
          },
          end: {
            line: 260,
            column: 1
          }
        },
        line: 223
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 228,
            column: 17
          },
          end: {
            line: 228,
            column: 18
          }
        },
        loc: {
          start: {
            line: 228,
            column: 34
          },
          end: {
            line: 254,
            column: 3
          }
        },
        line: 228
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 268,
            column: 34
          },
          end: {
            line: 268,
            column: 35
          }
        },
        loc: {
          start: {
            line: 268,
            column: 58
          },
          end: {
            line: 284,
            column: 1
          }
        },
        line: 268
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 270,
            column: 21
          },
          end: {
            line: 270,
            column: 22
          }
        },
        loc: {
          start: {
            line: 270,
            column: 36
          },
          end: {
            line: 282,
            column: 3
          }
        },
        line: 270
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 292,
            column: 41
          },
          end: {
            line: 292,
            column: 42
          }
        },
        loc: {
          start: {
            line: 292,
            column: 65
          },
          end: {
            line: 298,
            column: 1
          }
        },
        line: 292
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 305,
            column: 30
          },
          end: {
            line: 305,
            column: 31
          }
        },
        loc: {
          start: {
            line: 305,
            column: 42
          },
          end: {
            line: 338,
            column: 1
          }
        },
        line: 305
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 308,
            column: 28
          },
          end: {
            line: 308,
            column: 29
          }
        },
        loc: {
          start: {
            line: 308,
            column: 39
          },
          end: {
            line: 308,
            column: 47
          }
        },
        line: 308
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 309,
            column: 28
          },
          end: {
            line: 309,
            column: 29
          }
        },
        loc: {
          start: {
            line: 309,
            column: 39
          },
          end: {
            line: 309,
            column: 47
          }
        },
        line: 309
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 313,
            column: 17
          },
          end: {
            line: 313,
            column: 18
          }
        },
        loc: {
          start: {
            line: 313,
            column: 42
          },
          end: {
            line: 336,
            column: 3
          }
        },
        line: 313
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 346,
            column: 30
          },
          end: {
            line: 346,
            column: 31
          }
        },
        loc: {
          start: {
            line: 346,
            column: 54
          },
          end: {
            line: 351,
            column: 1
          }
        },
        line: 346
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 366,
            column: 34
          },
          end: {
            line: 366,
            column: 35
          }
        },
        loc: {
          start: {
            line: 366,
            column: 54
          },
          end: {
            line: 388,
            column: 1
          }
        },
        line: 366
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 368,
            column: 17
          },
          end: {
            line: 368,
            column: 18
          }
        },
        loc: {
          start: {
            line: 368,
            column: 28
          },
          end: {
            line: 386,
            column: 3
          }
        },
        line: 368
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 396,
            column: 34
          },
          end: {
            line: 396,
            column: 35
          }
        },
        loc: {
          start: {
            line: 396,
            column: 58
          },
          end: {
            line: 407,
            column: 1
          }
        },
        line: 396
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 399,
            column: 33
          },
          end: {
            line: 399,
            column: 34
          }
        },
        loc: {
          start: {
            line: 399,
            column: 48
          },
          end: {
            line: 402,
            column: 3
          }
        },
        line: 399
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 415,
            column: 45
          },
          end: {
            line: 415,
            column: 46
          }
        },
        loc: {
          start: {
            line: 419,
            column: 5
          },
          end: {
            line: 430,
            column: 1
          }
        },
        line: 419
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 422,
            column: 4
          },
          end: {
            line: 422,
            column: 5
          }
        },
        loc: {
          start: {
            line: 423,
            column: 6
          },
          end: {
            line: 426,
            column: 7
          }
        },
        line: 423
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 438,
            column: 40
          },
          end: {
            line: 438,
            column: 41
          }
        },
        loc: {
          start: {
            line: 438,
            column: 75
          },
          end: {
            line: 443,
            column: 1
          }
        },
        line: 438
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 451,
            column: 42
          },
          end: {
            line: 451,
            column: 43
          }
        },
        loc: {
          start: {
            line: 451,
            column: 65
          },
          end: {
            line: 472,
            column: 1
          }
        },
        line: 451
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 456,
            column: 24
          },
          end: {
            line: 456,
            column: 25
          }
        },
        loc: {
          start: {
            line: 456,
            column: 37
          },
          end: {
            line: 458,
            column: 5
          }
        },
        line: 456
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 482,
            column: 27
          },
          end: {
            line: 482,
            column: 28
          }
        },
        loc: {
          start: {
            line: 482,
            column: 50
          },
          end: {
            line: 495,
            column: 1
          }
        },
        line: 482
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 504,
            column: 41
          },
          end: {
            line: 504,
            column: 42
          }
        },
        loc: {
          start: {
            line: 504,
            column: 65
          },
          end: {
            line: 510,
            column: 1
          }
        },
        line: 504
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 505,
            column: 33
          },
          end: {
            line: 505,
            column: 34
          }
        },
        loc: {
          start: {
            line: 505,
            column: 48
          },
          end: {
            line: 508,
            column: 3
          }
        },
        line: 505
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 520,
            column: 35
          },
          end: {
            line: 520,
            column: 36
          }
        },
        loc: {
          start: {
            line: 520,
            column: 58
          },
          end: {
            line: 532,
            column: 1
          }
        },
        line: 520
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 534,
            column: 18
          },
          end: {
            line: 534,
            column: 19
          }
        },
        loc: {
          start: {
            line: 534,
            column: 28
          },
          end: {
            line: 540,
            column: 1
          }
        },
        line: 534
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 542,
            column: 31
          },
          end: {
            line: 542,
            column: 32
          }
        },
        loc: {
          start: {
            line: 542,
            column: 43
          },
          end: {
            line: 545,
            column: 1
          }
        },
        line: 542
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        }, {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 12,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 12,
            column: 11
          }
        }, {
          start: {
            line: 12,
            column: 15
          },
          end: {
            line: 12,
            column: 38
          }
        }],
        line: 12
      },
      "2": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }, {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }],
        line: 40
      },
      "3": {
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 17
          }
        }, {
          start: {
            line: 40,
            column: 21
          },
          end: {
            line: 40,
            column: 38
          }
        }],
        line: 40
      },
      "4": {
        loc: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        }, {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        }],
        line: 44
      },
      "5": {
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 23
          }
        }, {
          start: {
            line: 44,
            column: 27
          },
          end: {
            line: 44,
            column: 49
          }
        }],
        line: 44
      },
      "6": {
        loc: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        }, {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        }],
        line: 91
      },
      "7": {
        loc: {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 91,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 91,
            column: 23
          }
        }, {
          start: {
            line: 91,
            column: 27
          },
          end: {
            line: 91,
            column: 38
          }
        }],
        line: 91
      },
      "8": {
        loc: {
          start: {
            line: 120,
            column: 18
          },
          end: {
            line: 120,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 120,
            column: 18
          },
          end: {
            line: 120,
            column: 35
          }
        }, {
          start: {
            line: 120,
            column: 39
          },
          end: {
            line: 120,
            column: 41
          }
        }],
        line: 120
      },
      "9": {
        loc: {
          start: {
            line: 131,
            column: 64
          },
          end: {
            line: 131,
            column: 73
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 131,
            column: 72
          },
          end: {
            line: 131,
            column: 73
          }
        }],
        line: 131
      },
      "10": {
        loc: {
          start: {
            line: 135,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        }, {
          start: {
            line: 135,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        }],
        line: 135
      },
      "11": {
        loc: {
          start: {
            line: 231,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 231,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }, {
          start: {
            line: 231,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }],
        line: 231
      },
      "12": {
        loc: {
          start: {
            line: 255,
            column: 2
          },
          end: {
            line: 258,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 255,
            column: 2
          },
          end: {
            line: 258,
            column: 3
          }
        }, {
          start: {
            line: 255,
            column: 2
          },
          end: {
            line: 258,
            column: 3
          }
        }],
        line: 255
      },
      "13": {
        loc: {
          start: {
            line: 271,
            column: 4
          },
          end: {
            line: 281,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 271,
            column: 4
          },
          end: {
            line: 281,
            column: 5
          }
        }, {
          start: {
            line: 271,
            column: 4
          },
          end: {
            line: 281,
            column: 5
          }
        }],
        line: 271
      },
      "14": {
        loc: {
          start: {
            line: 271,
            column: 8
          },
          end: {
            line: 271,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 271,
            column: 8
          },
          end: {
            line: 271,
            column: 14
          }
        }, {
          start: {
            line: 271,
            column: 18
          },
          end: {
            line: 271,
            column: 49
          }
        }],
        line: 271
      },
      "15": {
        loc: {
          start: {
            line: 307,
            column: 2
          },
          end: {
            line: 307,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 307,
            column: 2
          },
          end: {
            line: 307,
            column: 41
          }
        }, {
          start: {
            line: 307,
            column: 2
          },
          end: {
            line: 307,
            column: 41
          }
        }],
        line: 307
      },
      "16": {
        loc: {
          start: {
            line: 318,
            column: 4
          },
          end: {
            line: 331,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 318,
            column: 4
          },
          end: {
            line: 331,
            column: 5
          }
        }, {
          start: {
            line: 318,
            column: 4
          },
          end: {
            line: 331,
            column: 5
          }
        }],
        line: 318
      },
      "17": {
        loc: {
          start: {
            line: 318,
            column: 8
          },
          end: {
            line: 318,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 318,
            column: 8
          },
          end: {
            line: 318,
            column: 36
          }
        }, {
          start: {
            line: 318,
            column: 40
          },
          end: {
            line: 318,
            column: 70
          }
        }],
        line: 318
      },
      "18": {
        loc: {
          start: {
            line: 320,
            column: 6
          },
          end: {
            line: 326,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 320,
            column: 6
          },
          end: {
            line: 326,
            column: 7
          }
        }, {
          start: {
            line: 320,
            column: 6
          },
          end: {
            line: 326,
            column: 7
          }
        }],
        line: 320
      },
      "19": {
        loc: {
          start: {
            line: 320,
            column: 10
          },
          end: {
            line: 320,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 320,
            column: 10
          },
          end: {
            line: 320,
            column: 36
          }
        }, {
          start: {
            line: 320,
            column: 40
          },
          end: {
            line: 320,
            column: 64
          }
        }],
        line: 320
      },
      "20": {
        loc: {
          start: {
            line: 329,
            column: 6
          },
          end: {
            line: 329,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 329,
            column: 6
          },
          end: {
            line: 329,
            column: 72
          }
        }, {
          start: {
            line: 329,
            column: 6
          },
          end: {
            line: 329,
            column: 72
          }
        }],
        line: 329
      },
      "21": {
        loc: {
          start: {
            line: 332,
            column: 4
          },
          end: {
            line: 335,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 332,
            column: 4
          },
          end: {
            line: 335,
            column: 5
          }
        }, {
          start: {
            line: 332,
            column: 4
          },
          end: {
            line: 335,
            column: 5
          }
        }],
        line: 332
      },
      "22": {
        loc: {
          start: {
            line: 332,
            column: 8
          },
          end: {
            line: 332,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 8
          },
          end: {
            line: 332,
            column: 35
          }
        }, {
          start: {
            line: 332,
            column: 39
          },
          end: {
            line: 332,
            column: 69
          }
        }],
        line: 332
      },
      "23": {
        loc: {
          start: {
            line: 382,
            column: 4
          },
          end: {
            line: 385,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 382,
            column: 4
          },
          end: {
            line: 385,
            column: 5
          }
        }, {
          start: {
            line: 382,
            column: 4
          },
          end: {
            line: 385,
            column: 5
          }
        }],
        line: 382
      },
      "24": {
        loc: {
          start: {
            line: 424,
            column: 8
          },
          end: {
            line: 425,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 424,
            column: 8
          },
          end: {
            line: 424,
            column: 54
          }
        }, {
          start: {
            line: 425,
            column: 8
          },
          end: {
            line: 425,
            column: 42
          }
        }],
        line: 424
      },
      "25": {
        loc: {
          start: {
            line: 453,
            column: 2
          },
          end: {
            line: 453,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 453,
            column: 2
          },
          end: {
            line: 453,
            column: 38
          }
        }, {
          start: {
            line: 453,
            column: 2
          },
          end: {
            line: 453,
            column: 38
          }
        }],
        line: 453
      },
      "26": {
        loc: {
          start: {
            line: 454,
            column: 2
          },
          end: {
            line: 460,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 454,
            column: 2
          },
          end: {
            line: 460,
            column: 3
          }
        }, {
          start: {
            line: 454,
            column: 2
          },
          end: {
            line: 460,
            column: 3
          }
        }],
        line: 454
      },
      "27": {
        loc: {
          start: {
            line: 461,
            column: 2
          },
          end: {
            line: 461,
            column: 76
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 461,
            column: 2
          },
          end: {
            line: 461,
            column: 76
          }
        }, {
          start: {
            line: 461,
            column: 2
          },
          end: {
            line: 461,
            column: 76
          }
        }],
        line: 461
      },
      "28": {
        loc: {
          start: {
            line: 466,
            column: 4
          },
          end: {
            line: 468,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 466,
            column: 4
          },
          end: {
            line: 468,
            column: 5
          }
        }, {
          start: {
            line: 466,
            column: 4
          },
          end: {
            line: 468,
            column: 5
          }
        }],
        line: 466
      },
      "29": {
        loc: {
          start: {
            line: 483,
            column: 2
          },
          end: {
            line: 483,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 483,
            column: 2
          },
          end: {
            line: 483,
            column: 38
          }
        }, {
          start: {
            line: 483,
            column: 2
          },
          end: {
            line: 483,
            column: 38
          }
        }],
        line: 483
      },
      "30": {
        loc: {
          start: {
            line: 490,
            column: 4
          },
          end: {
            line: 490,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 490,
            column: 4
          },
          end: {
            line: 490,
            column: 26
          }
        }, {
          start: {
            line: 490,
            column: 4
          },
          end: {
            line: 490,
            column: 26
          }
        }],
        line: 490
      },
      "31": {
        loc: {
          start: {
            line: 521,
            column: 2
          },
          end: {
            line: 521,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 521,
            column: 2
          },
          end: {
            line: 521,
            column: 38
          }
        }, {
          start: {
            line: 521,
            column: 2
          },
          end: {
            line: 521,
            column: 38
          }
        }],
        line: 521
      },
      "32": {
        loc: {
          start: {
            line: 527,
            column: 4
          },
          end: {
            line: 527,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 527,
            column: 4
          },
          end: {
            line: 527,
            column: 31
          }
        }, {
          start: {
            line: 527,
            column: 4
          },
          end: {
            line: 527,
            column: 31
          }
        }],
        line: 527
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0,
      "222": 0,
      "223": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "d4328f5dbfc08526fc93128268b66ea623460c77"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeString = exports.occurrencesInString = exports.checkSelectionOccurrences = exports.occurrences = exports.getQuoteOccurrencesInVerse = exports.addSelectionToSelections = exports.removeSelectionFromSelections = exports.optimizeSelections = exports.rangesToSelections = exports.selectionArray = exports.optimizeRanges = exports.selectionsToStringSplices = exports.selectionsToRanges = exports.spliceStringOnRanges = exports.generateSelection = exports.subSelectionsFromSubquote = exports.getPrecedingText = exports.getStringFromEllipsis = exports.getCurrentOccurrenceFromPrecedingText = exports.selectionsFromQuoteAndString = exports.getPrecedingOccurrences = exports.selectionsFromQuoteAndVerseObjects = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _lodash = _interopRequireDefault(require("lodash"));

var _stringPunctuationTokenizer = require("string-punctuation-tokenizer");

var _verseObjects = require("./verseObjects");

cov_2re07f8jxs.s[0]++;

var selectionsFromQuoteAndVerseObjects = function selectionsFromQuoteAndVerseObjects(_ref) {
  var quote = _ref.quote,
      verseObjects = _ref.verseObjects,
      occurrence = _ref.occurrence;
  cov_2re07f8jxs.f[0]++;
  var selections = (cov_2re07f8jxs.s[1]++, []);
  cov_2re07f8jxs.s[2]++;

  if ((cov_2re07f8jxs.b[1][0]++, quote) && (cov_2re07f8jxs.b[1][1]++, verseObjects.length > 0)) {
    cov_2re07f8jxs.b[0][0]++;
    var string = (cov_2re07f8jxs.s[3]++, (0, _verseObjects.verseObjectsToString)(verseObjects));
    cov_2re07f8jxs.s[4]++;
    selections = selectionsFromQuoteAndString({
      quote: quote,
      string: string,
      occurrence: occurrence
    });
  } else {
    cov_2re07f8jxs.b[0][1]++;
  }

  cov_2re07f8jxs.s[5]++;
  return selections;
};

exports.selectionsFromQuoteAndVerseObjects = selectionsFromQuoteAndVerseObjects;
cov_2re07f8jxs.s[6]++;

var getPrecedingOccurrences = function getPrecedingOccurrences(_string, subquote) {
  cov_2re07f8jxs.f[1]++;
  var precedingTokens = (cov_2re07f8jxs.s[7]++, tokenizer(_string));
  var precedingOccurrencesInPreviousString = (cov_2re07f8jxs.s[8]++, precedingTokens.reduce(function (n, val) {
    cov_2re07f8jxs.f[2]++;
    cov_2re07f8jxs.s[9]++;
    return n + (val === subquote);
  }, 0));
  cov_2re07f8jxs.s[10]++;
  return precedingOccurrencesInPreviousString;
};

exports.getPrecedingOccurrences = getPrecedingOccurrences;
cov_2re07f8jxs.s[11]++;

var selectionsFromQuoteAndString = function selectionsFromQuoteAndString(_ref2) {
  var quote = _ref2.quote,
      rawString = _ref2.string,
      occurrence = _ref2.occurrence;
  cov_2re07f8jxs.f[3]++;
  var string = (cov_2re07f8jxs.s[12]++, normalizeString(rawString));
  var subquotes = (cov_2re07f8jxs.s[13]++, quote.split('…').map(normalizeString));
  var selections = (cov_2re07f8jxs.s[14]++, []);
  var hasEllipsis = (cov_2re07f8jxs.s[15]++, subquotes.length > 1);
  cov_2re07f8jxs.s[16]++;

  if ((cov_2re07f8jxs.b[3][0]++, hasEllipsis) && (cov_2re07f8jxs.b[3][1]++, occurrence === -1)) {
    cov_2re07f8jxs.b[2][0]++;
    cov_2re07f8jxs.s[17]++;
    return [];
  } else {
    cov_2re07f8jxs.b[2][1]++;
  }

  cov_2re07f8jxs.s[18]++;

  if ((cov_2re07f8jxs.b[5][0]++, occurrence === -1) && (cov_2re07f8jxs.b[5][1]++, subquotes.length === 1)) {
    cov_2re07f8jxs.b[4][0]++;

    var _occurrences = (cov_2re07f8jxs.s[19]++, occurrencesInString(string, quote));

    cov_2re07f8jxs.s[20]++;
    subquotes = new Array(_occurrences).fill(quote);
  } else {
    cov_2re07f8jxs.b[4][1]++;
  }

  var precedingOccurrences = (cov_2re07f8jxs.s[21]++, 0);
  var precedingText = (cov_2re07f8jxs.s[22]++, '');
  cov_2re07f8jxs.s[23]++;
  subquotes.forEach(function (subquote, index) {
    cov_2re07f8jxs.f[4]++;
    cov_2re07f8jxs.s[24]++;
    precedingOccurrences = getPrecedingOccurrences(precedingText, subquote);
    var currentOccurrence = (cov_2re07f8jxs.s[25]++, getCurrentOccurrenceFromPrecedingText(occurrence, index, precedingOccurrences));
    cov_2re07f8jxs.s[26]++;
    precedingText = getPrecedingText(string, subquote, currentOccurrence, index);
    var subSelections = (cov_2re07f8jxs.s[27]++, subSelectionsFromSubquote({
      subquote: subquote,
      index: index,
      precedingText: precedingText,
      string: string
    }));
    cov_2re07f8jxs.s[28]++;
    subSelections.forEach(function (subSelection) {
      cov_2re07f8jxs.f[5]++;
      cov_2re07f8jxs.s[29]++;
      return selections.push(subSelection);
    });
    /** Adding the previous subquote to account for repeated ellipsis words i.e. Θεοῦ…Θεοῦ */

    cov_2re07f8jxs.s[30]++;
    precedingText += subquote;
  });
  cov_2re07f8jxs.s[31]++;
  return selections;
};
/**
 * This function gets the correct amount of occurrences to provide the function getPrecedingText
 *
 * @param {number} occurrence - The occurrence of the subquote in the string
 * @param {number} index - The current index of the subquotes
 * @param {number} precedingOccurrences - The number of occurrences before the current subquote in the string
 */


exports.selectionsFromQuoteAndString = selectionsFromQuoteAndString;
cov_2re07f8jxs.s[32]++;

var getCurrentOccurrenceFromPrecedingText = function getCurrentOccurrenceFromPrecedingText(occurrence, index, precedingOccurrences) {
  cov_2re07f8jxs.f[6]++;
  cov_2re07f8jxs.s[33]++;

  if ((cov_2re07f8jxs.b[7][0]++, occurrence === -1) || (cov_2re07f8jxs.b[7][1]++, index === 0)) {
    cov_2re07f8jxs.b[6][0]++;
    cov_2re07f8jxs.s[34]++;
    return occurrence;
  } else {
    cov_2re07f8jxs.b[6][1]++;
    cov_2re07f8jxs.s[35]++;
    return precedingOccurrences + 1;
  }
};
/**
 * This function will return the text in between
 * to ellipsis (inclusive of the container words) given the occurrence
 *
 * @param {string} _string - The string to search
 * @param {*} quote - The substring which contains an ellipsis to search for
 * @param {*} occurrence - The occurrence of the quote to search for
 */


exports.getCurrentOccurrenceFromPrecedingText = getCurrentOccurrenceFromPrecedingText;
cov_2re07f8jxs.s[36]++;

var getStringFromEllipsis = function getStringFromEllipsis(_string, quote, occurrence) {
  cov_2re07f8jxs.f[7]++;

  var _ref3 = (cov_2re07f8jxs.s[37]++, quote.split('…')),
      _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
      lower = _ref4[0],
      upper = _ref4[1];

  var reg = (cov_2re07f8jxs.s[38]++, new RegExp('(?:.*?' + lower + '.*' + upper + "){".concat(occurrence - 1, "}.*?(") + lower + '.*' + upper + ').*'));
  var string = (cov_2re07f8jxs.s[39]++, _string.slice(0));
  var matches = (cov_2re07f8jxs.s[40]++, (cov_2re07f8jxs.b[8][0]++, string.match(reg)) || (cov_2re07f8jxs.b[8][1]++, []));
  cov_2re07f8jxs.s[41]++;
  return matches[1];
};
/**
 *
 * @param {string} _string - The entire string to use to find the preceding text
 * @param {string} subquote - The subquote to find the preceding text of
 * @param {number} occurrence - The occurrence of the string in the entire string
 * @param {number} index - The index of the subquote
 */


exports.getStringFromEllipsis = getStringFromEllipsis;
cov_2re07f8jxs.s[42]++;

var getPrecedingText = function getPrecedingText(_string, subquote, occurrence) {
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (cov_2re07f8jxs.b[9][0]++, 0);
  cov_2re07f8jxs.f[8]++;
  var string = (cov_2re07f8jxs.s[43]++, _string.slice(0));
  var splitString = (cov_2re07f8jxs.s[44]++, string.split(subquote));
  cov_2re07f8jxs.s[45]++;

  if (occurrence === -1) {
    cov_2re07f8jxs.b[10][0]++;
    cov_2re07f8jxs.s[46]++; //Need every occurrence of the subquote
    //Using the index instead of the occurrence

    return splitString.slice(0, index + 1).join(subquote);
  } else {
    cov_2re07f8jxs.b[10][1]++;
    cov_2re07f8jxs.s[47]++; //Return the subquote at the specified occurrence
    //of the entire string

    return splitString.slice(0, occurrence).join(subquote);
  }
};

exports.getPrecedingText = getPrecedingText;
cov_2re07f8jxs.s[48]++;

var subSelectionsFromSubquote = function subSelectionsFromSubquote(_ref5) {
  var subquote = _ref5.subquote,
      _precedingText = _ref5.precedingText,
      string = _ref5.string;
  cov_2re07f8jxs.f[9]++; //Splitting by tokenization here causes issues because we are still
  //comparing those characters at this level

  var selectedTokens = (cov_2re07f8jxs.s[49]++, subquote.split(' '));
  var subSelections = (cov_2re07f8jxs.s[50]++, []);
  cov_2re07f8jxs.s[51]++;
  selectedTokens.forEach(function (_selectedText) {
    cov_2re07f8jxs.f[10]++; //Adding the preceding text from the subSelections to ensure that
    //Repeated words are accounted for

    var precedingTextInSubselections = (cov_2re07f8jxs.s[52]++, subSelections.map(function (_ref6) {
      var text = _ref6.text;
      cov_2re07f8jxs.f[11]++;
      cov_2re07f8jxs.s[53]++;
      return text;
    }).join(' '));
    var subSelection = (cov_2re07f8jxs.s[54]++, generateSelection({
      selectedText: _selectedText,
      precedingText: _precedingText + precedingTextInSubselections,
      entireText: string,
      subSelections: subSelections
    }));
    cov_2re07f8jxs.s[55]++;
    subSelections.push(subSelection);
  });
  cov_2re07f8jxs.s[56]++;
  return subSelections;
};
/**
 * Most everything below this is borrowed and adapted from
 * https://github.com/unfoldingWord/selections/blob/master/src/js/selections.js
 * and
 * https://github.com/unfoldingWord/tc-strings/blob/master/src/js/strings.js
 */

/**
 * @description - generates a selection object from the selected text, precedingText and whole text
 * @param {String} selectedText - the text that is selected
 * @param {String} precedingText - the text that prescedes the selection
 * @param {String} entireText - the text that the selection should be in
 * @return {Object} - the selection object to be used
 */


exports.subSelectionsFromSubquote = subSelectionsFromSubquote;
cov_2re07f8jxs.s[57]++;

var generateSelection = function generateSelection(_ref7) {
  var selectedText = _ref7.selectedText,
      precedingText = _ref7.precedingText,
      entireText = _ref7.entireText;
  cov_2re07f8jxs.f[12]++; // replace more than one contiguous space with a single one since HTML/selection only renders 1

  var _entireText = (cov_2re07f8jxs.s[58]++, normalizeString(entireText)); // Getting the occurrences before the current token


  var precedingTokens = (cov_2re07f8jxs.s[59]++, tokenizer(precedingText));
  var precedingOccurrencesInPreviousString = (cov_2re07f8jxs.s[60]++, precedingTokens.reduce(function (n, val) {
    cov_2re07f8jxs.f[13]++;
    cov_2re07f8jxs.s[61]++;
    return n + (val === selectedText);
  }, 0)); // calculate this occurrence number by adding it to the preceding ones

  var occurrence = (cov_2re07f8jxs.s[62]++, precedingOccurrencesInPreviousString + 1); // get the total occurrences from the verse

  var allTokens = (cov_2re07f8jxs.s[63]++, tokenizer(_entireText));
  var allOccurrences = (cov_2re07f8jxs.s[64]++, allTokens.reduce(function (n, val) {
    cov_2re07f8jxs.f[14]++;
    cov_2re07f8jxs.s[65]++;
    return n + (val === selectedText);
  }, 0));
  cov_2re07f8jxs.s[66]++;
  return {
    text: selectedText,
    occurrence: occurrence,
    occurrences: allOccurrences
  };
};
/**
 * @description - Splice string into array of ranges, flagging what is selected
 * @param {array} ranges - array of ranges [[int,int],...]
 * @returns {array} - array of objects [obj,...]
 */


exports.generateSelection = generateSelection;
cov_2re07f8jxs.s[67]++;

var spliceStringOnRanges = function spliceStringOnRanges(string, ranges) {
  cov_2re07f8jxs.f[15]++;
  var selectionArray = (cov_2re07f8jxs.s[68]++, []); // response

  var remainingString = (cov_2re07f8jxs.s[69]++, string); // shift the range since the loop is destructive by working on the remainingString and not original string

  var rangeShift = (cov_2re07f8jxs.s[70]++, 0); // start the range shift at the first character

  cov_2re07f8jxs.s[71]++;
  ranges.forEach(function (range) {
    cov_2re07f8jxs.f[16]++;
    var firstCharacterPosition = (cov_2re07f8jxs.s[72]++, range[0] - rangeShift); // original range start - the rangeShift

    var beforeSelection = (cov_2re07f8jxs.s[73]++, remainingString.slice(0, firstCharacterPosition)); // save all the text before the selection

    cov_2re07f8jxs.s[74]++;

    if (beforeSelection) {
      cov_2re07f8jxs.b[11][0]++;
      cov_2re07f8jxs.s[75]++; // only add to the array if string isn't empty

      selectionArray.push({
        text: beforeSelection,
        selected: false
      });
    } else {
      cov_2re07f8jxs.b[11][1]++;
    }

    var shiftedRangeStart = (cov_2re07f8jxs.s[76]++, range[0] - rangeShift); // range start - the rangeShift

    var shiftedRangeEnd = (cov_2re07f8jxs.s[77]++, range[1] + 1 - rangeShift); // range end - rangeShift + 1 to include last character

    var selection = (cov_2re07f8jxs.s[78]++, remainingString.slice(shiftedRangeStart, shiftedRangeEnd)); // save the text in the selection

    var stringBeforeRange = (cov_2re07f8jxs.s[79]++, string.slice(0, range[0]));
    var occurrence = (cov_2re07f8jxs.s[80]++, occurrencesInString(stringBeforeRange, selection) + 1);
    var occurrences = (cov_2re07f8jxs.s[81]++, occurrencesInString(string, selection));
    var selectionObject = (cov_2re07f8jxs.s[82]++, {
      text: selection,
      selected: true,
      occurrence: occurrence,
      occurrences: occurrences
    });
    cov_2re07f8jxs.s[83]++;
    selectionArray.push(selectionObject); // add the selection to the response array
    // next iteration is using remaining string

    var lastCharacterPosition = (cov_2re07f8jxs.s[84]++, range[1] - rangeShift + 1); // original range end position - the rangeShift + 1 to not include the last range character in the remaining string

    cov_2re07f8jxs.s[85]++;
    remainingString = remainingString.slice(lastCharacterPosition); // update the remainingString to after the range
    // shift the range up to last char of substring (before+sub)

    cov_2re07f8jxs.s[86]++;
    rangeShift += beforeSelection.length; // adjust the rangeShift by the length prior to the selection

    cov_2re07f8jxs.s[87]++;
    rangeShift += selection.length; // adjust the rangeShift by the length of the selection itself
  });
  cov_2re07f8jxs.s[88]++;

  if (remainingString) {
    cov_2re07f8jxs.b[12][0]++;
    cov_2re07f8jxs.s[89]++; // only add to the array if string isn't empty

    selectionArray.push({
      text: remainingString,
      selected: false
    });
  } else {
    cov_2re07f8jxs.b[12][1]++;
  }

  cov_2re07f8jxs.s[90]++;
  return selectionArray;
};
/**
 * @description - This converts ranges to array of selection objects
 * @param {string} string - text used to get the ranges of
 * @param {array} selections - array of selections [obj,...]
 * @returns {array} - array of range objects
 */


exports.spliceStringOnRanges = spliceStringOnRanges;
cov_2re07f8jxs.s[91]++;

var selectionsToRanges = function selectionsToRanges(string, selections) {
  cov_2re07f8jxs.f[17]++;
  var ranges = (cov_2re07f8jxs.s[92]++, []); // response

  cov_2re07f8jxs.s[93]++;
  selections.forEach(function (selection) {
    cov_2re07f8jxs.f[18]++;
    cov_2re07f8jxs.s[94]++;

    if ((cov_2re07f8jxs.b[14][0]++, string) && (cov_2re07f8jxs.b[14][1]++, string.includes(selection.text))) {
      cov_2re07f8jxs.b[13][0]++; // conditions to prevent errors

      var splitArray = (cov_2re07f8jxs.s[95]++, string.split(selection.text)); // split the string to get the text between occurrences

      var beforeSelection = (cov_2re07f8jxs.s[96]++, splitArray.slice(0, selection.occurrence).join(selection.text)); // get the text before the selection to handle multiple occurrences

      var start = (cov_2re07f8jxs.s[97]++, beforeSelection.length); // the start position happens at the length of the string that comes before it

      var end = (cov_2re07f8jxs.s[98]++, start + selection.text.length - 1); // the end position happens at the end of the selection text, but length doesn't account for 0 based position start

      var range = (cov_2re07f8jxs.s[99]++, [start, end]); // new range

      cov_2re07f8jxs.s[100]++;
      ranges.push(range); // add the new range
    } else {
      cov_2re07f8jxs.b[13][1]++;
    }
  });
  cov_2re07f8jxs.s[101]++;
  return ranges;
};
/**
 * @description - Splice string into array of substrings, flagging what is selected
 * @param {string} string - text used to get the ranges of
 * @param {array} selections - array of selections [obj,...]
 * @returns {array} - array of objects
 */


exports.selectionsToRanges = selectionsToRanges;
cov_2re07f8jxs.s[102]++;

var selectionsToStringSplices = function selectionsToStringSplices(string, selections) {
  cov_2re07f8jxs.f[19]++;
  var splicedStringArray = (cov_2re07f8jxs.s[103]++, []); // response

  cov_2re07f8jxs.s[104]++;
  selections = optimizeSelections(string, selections); // optimize them before converting

  var ranges = (cov_2re07f8jxs.s[105]++, selectionsToRanges(string, selections)); // convert the selections to ranges

  cov_2re07f8jxs.s[106]++;
  splicedStringArray = spliceStringOnRanges(string, ranges); // splice the string on the ranges

  cov_2re07f8jxs.s[107]++;
  return splicedStringArray; // return the spliced string
};
/**
 * @description - This abstracts complex handling of ranges such as order, deduping, concatenating, overlaps
 * @param {array}  ranges - array of ranges [[int,int],...]
 * @returns {array} - array of optimized ranges [[int,int],...]
 */


exports.selectionsToStringSplices = selectionsToStringSplices;
cov_2re07f8jxs.s[108]++;

var optimizeRanges = function optimizeRanges(ranges) {
  cov_2re07f8jxs.f[20]++;
  var optimizedRanges = (cov_2re07f8jxs.s[109]++, []); // response

  cov_2re07f8jxs.s[110]++;

  if (ranges.length === 1) {
    cov_2re07f8jxs.b[15][0]++;
    cov_2re07f8jxs.s[111]++;
    return ranges;
  } else {
    cov_2re07f8jxs.b[15][1]++;
  } // if there's only one, return it


  cov_2re07f8jxs.s[112]++;
  ranges = _lodash.default.sortBy(ranges, function (range) {
    cov_2re07f8jxs.f[21]++;
    cov_2re07f8jxs.s[113]++;
    return range[1];
  }); // order ranges by end char index as secondary

  cov_2re07f8jxs.s[114]++;
  ranges = _lodash.default.sortBy(ranges, function (range) {
    cov_2re07f8jxs.f[22]++;
    cov_2re07f8jxs.s[115]++;
    return range[0];
  }); // order ranges by start char index as primary

  cov_2re07f8jxs.s[116]++;
  ranges = _lodash.default.uniq(ranges); // remove duplicates
  // combine overlapping and contiguous ranges

  var runningRange = (cov_2re07f8jxs.s[117]++, []); // the running range to merge overlapping and contiguous ranges

  cov_2re07f8jxs.s[118]++;
  ranges.forEach(function (currentRange, index) {
    cov_2re07f8jxs.f[23]++;
    var currentStart = (cov_2re07f8jxs.s[119]++, currentRange[0]);
    var currentEnd = (cov_2re07f8jxs.s[120]++, currentRange[1]);
    var runningStart = (cov_2re07f8jxs.s[121]++, runningRange[0]);
    var runningEnd = (cov_2re07f8jxs.s[122]++, runningRange[1]);
    cov_2re07f8jxs.s[123]++;

    if ((cov_2re07f8jxs.b[17][0]++, currentStart >= runningStart) && (cov_2re07f8jxs.b[17][1]++, currentStart <= runningEnd + 1)) {
      cov_2re07f8jxs.b[16][0]++;
      cov_2re07f8jxs.s[124]++; // the start occurs in the running range and +1 handles contiguous

      if ((cov_2re07f8jxs.b[19][0]++, currentEnd >= runningStart) && (cov_2re07f8jxs.b[19][1]++, currentEnd <= runningEnd)) {
        // if the start occurs inside running range then let's check the end
        // if the end occurs inside the running range then it's inside it and doesn't matter
        cov_2re07f8jxs.b[18][0]++;
      } else {
        cov_2re07f8jxs.b[18][1]++;
        cov_2re07f8jxs.s[125]++; // the end doesn't occur inside the running range

        runningRange[1] = runningEnd = currentEnd; // extend running range
      }
    } else {
      cov_2re07f8jxs.b[16][1]++;
      cov_2re07f8jxs.s[126]++; // the start does not occur in the running range

      if (runningRange.length !== 0) {
        cov_2re07f8jxs.b[20][0]++;
        cov_2re07f8jxs.s[127]++;
        optimizedRanges.push(runningRange);
      } else {
        cov_2re07f8jxs.b[20][1]++;
      } // the running range is closed push it to optimizedRanges


      cov_2re07f8jxs.s[128]++;
      runningRange = currentRange; // reset the running range to this one
    }

    cov_2re07f8jxs.s[129]++;

    if ((cov_2re07f8jxs.b[22][0]++, ranges.length === index + 1) && (cov_2re07f8jxs.b[22][1]++, runningEnd - runningStart >= 0)) {
      cov_2re07f8jxs.b[21][0]++;
      cov_2re07f8jxs.s[130]++; // this is the last one and it isn't blank

      optimizedRanges.push(runningRange); // push the last one to optimizedRanges
    } else {
      cov_2re07f8jxs.b[21][1]++;
    }
  });
  cov_2re07f8jxs.s[131]++;
  return optimizedRanges;
};
/**
 * Splice string into array of substrings, flagging what is selected
 * @param {string} string - text used to get the ranges of
 * @param {array} selections - array of selections [obj,...]
 * @return {array} - array of objects
 */


exports.optimizeRanges = optimizeRanges;
cov_2re07f8jxs.s[132]++;

var selectionArray = function selectionArray(string, selections) {
  cov_2re07f8jxs.f[24]++;
  var selectionArray = (cov_2re07f8jxs.s[133]++, []);
  var ranges = (cov_2re07f8jxs.s[134]++, module.exports.selectionsToRanges(string, selections));
  cov_2re07f8jxs.s[135]++;
  selectionArray = module.exports.spliceStringOnRanges(string, ranges);
  cov_2re07f8jxs.s[136]++;
  return selectionArray;
}; //
// Use the following lines to test the previous function
// let string = "01 234 56789qwertyuiopasdfghjklzxcvbnmtyui01 234 567890"
// let selections = [
//   { text: '234', occurrence: 2, occurrences: 2 },
// ]
// console.log(module.exports.selectionArray(string, selections))

/**
 * @description - This converts ranges to array of selection objects
 * @param {string} string - text used to get the ranges of
 * @param {array} ranges - array of ranges [[int,int],...]
 * @return {array} - array of selection objects
 */


exports.selectionArray = selectionArray;
cov_2re07f8jxs.s[137]++;

var rangesToSelections = function rangesToSelections(string, ranges) {
  cov_2re07f8jxs.f[25]++;
  var selections = (cov_2re07f8jxs.s[138]++, []);
  cov_2re07f8jxs.s[139]++;
  ranges.forEach(function (range) {
    cov_2re07f8jxs.f[26]++;
    var start = (cov_2re07f8jxs.s[140]++, range[0]); // set the start point

    var end = (cov_2re07f8jxs.s[141]++, range[1]); // set the end point

    var length = (cov_2re07f8jxs.s[142]++, end - start + 1); // get the length of the sub string

    var subString = (cov_2re07f8jxs.s[143]++, string.substr(start, length)); // get text of the sub string

    var beforeText = (cov_2re07f8jxs.s[144]++, string.substr(0, start)); // get the string prior to the range

    var beforeMatches = (cov_2re07f8jxs.s[145]++, occurrencesInString(beforeText, subString)); // get occurrences prior to range

    var occurrence = (cov_2re07f8jxs.s[146]++, beforeMatches + 1); // get number of this occurrence

    var occurrences = (cov_2re07f8jxs.s[147]++, occurrencesInString(string, subString)); // get occurrences in string

    var selection = (cov_2re07f8jxs.s[148]++, {
      text: subString,
      occurrence: occurrence,
      occurrences: occurrences
    });
    cov_2re07f8jxs.s[149]++;

    if (occurrences > 0) {
      cov_2re07f8jxs.b[23][0]++;
      cov_2re07f8jxs.s[150]++; // there are some edge cases where empty strings get through but don't have occurrences

      selections.push(selection);
    } else {
      cov_2re07f8jxs.b[23][1]++;
    }
  });
  cov_2re07f8jxs.s[151]++;
  return selections;
};
/**
 * @description - This abstracts complex handling of selections such as order, deduping, concatenating, overlapping ranges
 * @param {string} string - the text selections are found in
 * @param {array}  selections - array of selection objects [Obj,...]
 * @returns {array} - array of selection objects
 */


exports.rangesToSelections = rangesToSelections;
cov_2re07f8jxs.s[152]++;

var optimizeSelections = function optimizeSelections(string, selections) {
  cov_2re07f8jxs.f[27]++;
  var optimizedSelections; // return
  // filter out the random clicks from the UI

  cov_2re07f8jxs.s[153]++;
  selections = selections.filter(function (selection) {
    cov_2re07f8jxs.f[28]++;
    var blankSelection = (cov_2re07f8jxs.s[154]++, {
      text: '',
      occurrence: 1,
      occurrences: 0
    });
    cov_2re07f8jxs.s[155]++;
    return !(0, _deepEqual.default)(selection, blankSelection);
  });
  var ranges = (cov_2re07f8jxs.s[156]++, selectionsToRanges(string, selections)); // get char ranges of each selection

  cov_2re07f8jxs.s[157]++;
  ranges = optimizeRanges(ranges); // optimize the ranges

  cov_2re07f8jxs.s[158]++;
  optimizedSelections = rangesToSelections(string, ranges); // convert optimized ranges into selections

  cov_2re07f8jxs.s[159]++;
  return optimizedSelections;
};
/**
 * @description - Removes a selection if found in the array of selections
 * @param {Object} selection - the selection to remove
 * @param {Array}  selections - array of selection objects [Obj,...]
 * @param {string} string - the text selections are found in
 * @returns {Array} - array of selection objects
 */


exports.optimizeSelections = optimizeSelections;
cov_2re07f8jxs.s[160]++;

var removeSelectionFromSelections = function removeSelectionFromSelections(selection, selections, string) {
  cov_2re07f8jxs.f[29]++;
  cov_2re07f8jxs.s[161]++;
  selections = Array.from(selections);
  cov_2re07f8jxs.s[162]++;
  selections = selections.filter(function (_selection) {
    cov_2re07f8jxs.f[30]++;
    cov_2re07f8jxs.s[163]++;
    return !((cov_2re07f8jxs.b[24][0]++, _selection.occurrence === selection.occurrence) && (cov_2re07f8jxs.b[24][1]++, _selection.text === selection.text));
  });
  cov_2re07f8jxs.s[164]++;
  selections = optimizeSelections(string, selections);
  cov_2re07f8jxs.s[165]++;
  return selections;
};
/**
 * @description - Removes a selection if found in the array of selections
 * @param {Object} selection - the selection to remove
 * @param {Array}  selections - array of selection objects [Obj,...]
 * @param {string} string - the text selections are found in
 * @returns {Array} - array of selection objects
 */


exports.removeSelectionFromSelections = removeSelectionFromSelections;
cov_2re07f8jxs.s[166]++;

var addSelectionToSelections = function addSelectionToSelections(selection, selections, string) {
  cov_2re07f8jxs.f[31]++;
  cov_2re07f8jxs.s[167]++;
  selections = Array.from(selections);
  cov_2re07f8jxs.s[168]++;
  selections.push(selection);
  cov_2re07f8jxs.s[169]++;
  selections = optimizeSelections(string, selections);
  cov_2re07f8jxs.s[170]++;
  return selections;
};
/**
 *
 * @param {string} string - Entire string to search within 'Blessed be the name of the Lord'
 * @param {string} subString - substring to search for inside of entire string i.e. 'bless, blessed, blessing'
 * @return {number}
 */


exports.addSelectionToSelections = addSelectionToSelections;
cov_2re07f8jxs.s[171]++;

var getQuoteOccurrencesInVerse = function getQuoteOccurrencesInVerse(string, subString) {
  cov_2re07f8jxs.f[32]++;
  var n = (cov_2re07f8jxs.s[172]++, 0);
  cov_2re07f8jxs.s[173]++;

  if (subString.length <= 0) {
    cov_2re07f8jxs.b[25][0]++;
    cov_2re07f8jxs.s[174]++;
    return 0;
  } else {
    cov_2re07f8jxs.b[25][1]++;
  }

  cov_2re07f8jxs.s[175]++;

  if (subString.split(',').length > 1) {
    cov_2re07f8jxs.b[26][0]++;
    var stringArray = (cov_2re07f8jxs.s[176]++, subString.split(','));
    cov_2re07f8jxs.s[177]++;
    stringArray.forEach(function (element) {
      cov_2re07f8jxs.f[33]++;
      cov_2re07f8jxs.s[178]++;
      n += getQuoteOccurrencesInVerse(string, element.trim());
    });
    cov_2re07f8jxs.s[179]++;
    return n;
  } else {
    cov_2re07f8jxs.b[26][1]++;
  }

  cov_2re07f8jxs.s[180]++;

  if (subString.includes('...')) {
    cov_2re07f8jxs.b[27][0]++;
    cov_2re07f8jxs.s[181]++;
    subString = subString.replace('...', '.*');
  } else {
    cov_2re07f8jxs.b[27][1]++;
  }

  var regex = (cov_2re07f8jxs.s[182]++, new RegExp("\\W+".concat(subString, "\\W+"), 'g'));
  var matchedSubstring;
  cov_2re07f8jxs.s[183]++;

  while ((matchedSubstring = regex.exec(string)) !== null) {
    cov_2re07f8jxs.s[184]++; // This is necessary to avoid infinite loops with zero-width matchedSubstring

    if (matchedSubstring.index === regex.lastIndex) {
      cov_2re07f8jxs.b[28][0]++;
      cov_2re07f8jxs.s[185]++;
      regex.lastIndex++;
    } else {
      cov_2re07f8jxs.b[28][1]++;
    }

    cov_2re07f8jxs.s[186]++;
    n++;
  }

  cov_2re07f8jxs.s[187]++;
  return n;
};
/**
 * @description Function that count occurrences of a substring in a string
 * @param {String} string - The string to search in
 * @param {String} subString - The sub string to search for
 * @return {Integer} - the count of the occurrences
 * @see http://stackoverflow.com/questions/4009756/how-to-count-string-occurrence-in-string/7924240#7924240
 * modified to fit our use cases, return zero for '' substring, and no use case for overlapping.
 */


exports.getQuoteOccurrencesInVerse = getQuoteOccurrencesInVerse;
cov_2re07f8jxs.s[188]++;

var occurrences = function occurrences(string, subString) {
  cov_2re07f8jxs.f[34]++;
  cov_2re07f8jxs.s[189]++;

  if (subString.length <= 0) {
    cov_2re07f8jxs.b[29][0]++;
    cov_2re07f8jxs.s[190]++;
    return 0;
  } else {
    cov_2re07f8jxs.b[29][1]++;
  }

  var n = (cov_2re07f8jxs.s[191]++, 0);
  var pos = (cov_2re07f8jxs.s[192]++, 0);
  var step = (cov_2re07f8jxs.s[193]++, subString.length); // eslint-disable-next-line no-constant-condition

  cov_2re07f8jxs.s[194]++;

  while (true) {
    cov_2re07f8jxs.s[195]++;
    pos = string.indexOf(subString, pos);
    cov_2re07f8jxs.s[196]++;

    if (pos === -1) {
      cov_2re07f8jxs.b[30][0]++;
      cov_2re07f8jxs.s[197]++;
      break;
    } else {
      cov_2re07f8jxs.b[30][1]++;
    }

    cov_2re07f8jxs.s[198]++;
    ++n;
    cov_2re07f8jxs.s[199]++;
    pos += step;
  }

  cov_2re07f8jxs.s[200]++;
  return n;
};
/**
 * @description This checks to see if the string still has the same number of occurrences.
 * It should remove the selections that the occurrences do not match
 * @param {string} string - the text selections are found in
 * @param {array}  selections - array of selection objects [Obj,...]
 * @returns {array} - array of selection objects
 */


exports.occurrences = occurrences;
cov_2re07f8jxs.s[201]++;

var checkSelectionOccurrences = function checkSelectionOccurrences(string, selections) {
  cov_2re07f8jxs.f[35]++;
  cov_2re07f8jxs.s[202]++;
  selections = selections.filter(function (selection) {
    cov_2re07f8jxs.f[36]++;
    var count = (cov_2re07f8jxs.s[203]++, occurrences(string, selection.text));
    cov_2re07f8jxs.s[204]++;
    return count === selection.occurrences;
  });
  cov_2re07f8jxs.s[205]++;
  return selections;
};
/**
 * @description Function that count occurrences of a substring in a string
 * @param {String} string - The string to search in
 * @param {String} subString - The sub string to search for
 * @return {Integer} - the count of the occurrences
 * @see http://stackoverflow.com/questions/4009756/how-to-count-string-occurrence-in-string/7924240#7924240
 * modified to fit our use cases, return zero for '' substring, and no use case for overlapping.
 */


exports.checkSelectionOccurrences = checkSelectionOccurrences;
cov_2re07f8jxs.s[206]++;

var occurrencesInString = function occurrencesInString(string, subString) {
  cov_2re07f8jxs.f[37]++;
  cov_2re07f8jxs.s[207]++;

  if (subString.length <= 0) {
    cov_2re07f8jxs.b[31][0]++;
    cov_2re07f8jxs.s[208]++;
    return 0;
  } else {
    cov_2re07f8jxs.b[31][1]++;
  }

  var occurrences = (cov_2re07f8jxs.s[209]++, 0);
  var position = (cov_2re07f8jxs.s[210]++, 0);
  var step = (cov_2re07f8jxs.s[211]++, subString.length);
  cov_2re07f8jxs.s[212]++;

  while (position < string.length) {
    cov_2re07f8jxs.s[213]++;
    position = string.indexOf(subString, position);
    cov_2re07f8jxs.s[214]++;

    if (position === -1) {
      cov_2re07f8jxs.b[32][0]++;
      cov_2re07f8jxs.s[215]++;
      break;
    } else {
      cov_2re07f8jxs.b[32][1]++;
    }

    cov_2re07f8jxs.s[216]++;
    ++occurrences;
    cov_2re07f8jxs.s[217]++;
    position += step;
  }

  cov_2re07f8jxs.s[218]++;
  return occurrences;
};

exports.occurrencesInString = occurrencesInString;
cov_2re07f8jxs.s[219]++;

var tokenizer = function tokenizer(text) {
  cov_2re07f8jxs.f[38]++;
  cov_2re07f8jxs.s[220]++;
  return (0, _stringPunctuationTokenizer.tokenize)({
    text: text,
    greedy: true,
    normalize: true
  });
};

cov_2re07f8jxs.s[221]++;

var normalizeString = function normalizeString(string) {
  cov_2re07f8jxs.f[39]++;
  var normalized = (cov_2re07f8jxs.s[222]++, tokenizer(string).join(' '));
  cov_2re07f8jxs.s[223]++;
  return normalized;
};

exports.normalizeString = normalizeString;